export default [
    {
        // 首页
        path: '/',
        name: 'home',
        component: () => import('@/views/home'),
        meta: {
            title: '数位大数据-商业智能和大数据科技引领者',
            content: {
                keywords:
                    '线下大数据,开店数字化,数据服务,上上参谋,拓店云,线下数据采集,城市数据,商圈数据,商场数据,商铺数据.',
                description:
                    '数位是一家专注于商业智能的大数据科技公司,由蚂蚁金服,博将,赛富等知名机构投资.以数据驱动线下商业决策,提供专业,普惠的智能产品,助力实体经济数字化转型.'
            }
        }
    },
    {
        // 拓店云首页
        path: '/cloudHome',
        name: 'cloudHome',
        component: () => import('@/views/digitalCloud/cloudHome'),
        meta: {
            title: '上上参谋企业版-专业的连锁拓店管理系统',
            content: {
                keywords:
                    '网规选址,战略规划,选址咨询,铺位选址分析,选址评估报告,选址工具,选址软件,铺位位置,选址评估,选址方案.',
                description:
                    '上上参谋企业版由蚂蚁金服战投企业数位推出的“连锁拓店管理系统”。用”工具+数据+模型“帮助连锁品牌节省品牌拓展成本、保障规模化扩张成功率、提升拓店管理效率。助力连锁品牌高效、高质量发展。'
            }
        }
    },
    {
        // 拓店云产品
        path: '/cloudProduct',
        name: 'cloudProduct',
        component: () => import('@/views/digitalCloud/product'),
        meta: {
            title: '产品'
        }
    },
    {
        // 拓店云解决方案详情
        path: '/cloudSchemeDetails',
        name: 'cloudSchemeDetails',
        component: () => import('@/views/digitalCloud/schemeDetails'),
        meta: {
            title: '解决方案'
        }
    },
    {
        // 上上参谋首页
        path: '/superiorStaffHome',
        name: 'superiorStaffHome',
        component: () => import('@/views/superiorStaff/superiorStaffHome'),
        meta: {
            title: '上上参谋-开店选址,品牌加盟,商铺信息',
            content: {
                keywords:
                    '开店选址,位置评估,品牌分析,商圈分析,选址方法,人口热力,店铺信息,开店选址评估,外卖店选址,开店位置推荐.',
                description:
                    '上上参谋APP是由蚂蚁金服战投企业「数位」开发的一款数字化开店产品,为用户提供开店选址,品牌加盟,商铺信息分析等大数据智能决策,已为超500万开店者提供超1亿次选址支持.'
            }
        }
    },
    {
        // 上上参谋服务
        path: '/superiorStaffService',
        name: 'superiorStaffService',
        component: () => import('@/views/superiorStaff/service'),
        meta: {
            title: '服务市场'
        }
    },
    {
        // 上上参谋品牌
        path: '/superiorStaffBrand',
        name: 'superiorStaffBrand',
        component: () => import('@/views/superiorStaff/brand'),
        meta: {
            title: '品牌专区'
        }
    },
    {
        // 开放生态
        path: '/openEcology',
        name: 'openEcology',
        component: () => import('@/views/openEcology'),
        meta: {
            title: '加入数位开放生态'
        }
    },
    {
        // 加入我们
        path: '/joinUs',
        name: 'joinUs',
        component: () => import('@/views/joinUs/index'),
        meta: {
            title: '加入数位 共创未来'
        }
    },
    {
        // sitemap
        path: '/sitemap',
        name: 'sitemap',
        component: () => import('@/views/sitemap'),
        meta: {
            title: '网站地图'
        }
    },
    {
        // sitemap
        path: '/sitemap',
        name: 'sitemap',
        component: () => import('@/views/sitemap'),
        meta: {
            title: '网站地图'
        }
    },
    {
        // 免责声明
        path: '/disclaimers',
        name: 'disclaimers',
        component: () => import('@/views/disclaimers'),
        meta: {
            title: '免责声明'
        }
    },
    {
        // 隐私政策
        path: '/privacyPolicy',
        name: 'privacyPolicy',
        component: () => import('@/views/privacyPolicy'),
        meta: {
            title: '隐私政策'
        }
    },
    {
        // 招聘
        path: '/job',
        name: 'job',
        component: () => import('@/views/job'),
        meta: {
            title: '招聘信息'
        }
    },
    {
        // 关于我们
        path: '/about',
        name: 'about',
        component: () => import('@/views/about'),
        meta: {
            title: '关于我们'
        }
    },
    {
        // 404
        path: '*',
        name: '404',
        component: () => import('@/views/404'),
        meta: {
            title: '404'
        }
    }
];
